import Vue from 'vue';
import siteService from '@/project/site/site.service';

const locale = siteService.getCulture();

function localeNumberFilter(number: number | string) {
    if (typeof number !== 'number') return number;
    if (!locale) return number;

    return number.toLocaleString(locale);
}

Vue.filter('localeNumber', localeNumberFilter);

export default localeNumberFilter;
